import { useTranslation } from 'react-i18next';
import { ButtonPropsWithLabel } from 'src/components/Dialog';

import { BlockingReasonRow } from './BlockingReasonRow';

export function CustomBlockingReason({
  actions,
  title,
  message,
}: {
  actions?: ButtonPropsWithLabel[];
  title?: string;
  message: string;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  return (
    <BlockingReasonRow
      title={title || t('blockingReasons.custom.title')}
      message={message || t('blockingReasons.custom.message')}
      actions={actions}
    />
  );
}
